import { Pipe, PipeTransform } from '@angular/core';
import { FormControl } from '@angular/forms';

@Pipe({
    name: 'input',
    standalone: true,
    pure: false,
})
export class InputPipe implements PipeTransform {
    public transform(value: FormControl<string | null> | null, label?: string | null): string {
        if (!value) {
            return '';
        }
        if (value.dirty || value.touched) {
            const errors = value.errors;
            if (label) {
                if (errors?.['mask']) {
                    const requiredMask = errors['mask'].requiredMask;
                    return $localize`Enter valid ${label.toLowerCase()} example: ${requiredMask}`;
                }
                if (errors?.['required']) {
                    return $localize`${label} is required`;
                }
            }
            if (errors?.['maxlength']) {
                const requiredLength = errors['maxlength'].requiredLength;
                const actualLength = errors['maxlength'].actualLength;
                return $localize`Maximum length is ${requiredLength}, but got ${actualLength}`;
            }
            if (errors?.['email']) {
                return $localize`Enter correct email example@example.com`;
            }
        }
        return '';
    }
}
